import type { TocItem } from "@/lib/blog/toc";

interface Props {
  items: TocItem[];
}

export function BlogTableOfContents({ items }: Props) {
  if (items.length < 2) return null;
  return (
    <nav
      aria-label="On this page"
      className="rounded-3xl border border-border bg-card p-5 shadow-sm"
    >
        <p className="text-caption font-semibold uppercase tracking-wide text-muted-foreground mb-3">
          On this page
        </p>
        <ol className="text-body-sm space-y-1">
          {items.map((it) => (
            <li key={it.id}>
              <a
                href={`#${it.id}`}
                className="block min-h-[44px] px-3 py-2.5 rounded-lg text-foreground/75 hover:bg-muted/60 hover:text-primary transition-colors leading-snug focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring"
              >
                {it.text}
              </a>
            </li>
          ))}
        </ol>
    </nav>
  );
}